import React from "react";
import Card from "./card";
import Avatar from "./avatar";
import Badge from "./badge";
import { Player } from "./types";

export const PlayerCard: React.FC<{ player: Player; subtitle?: string }>= ({ player, subtitle }) => (
  <Card>
    <div className="u-row u-gap-12">
      <Avatar name={player.name} />
      <div className="u-col">
        <div className="card__header">{player.name}</div>
        {subtitle && <div className="card__meta">{subtitle}</div>}
        <div style={{ marginTop: 6 }}><Badge kind="highlight">NYC</Badge></div>
      </div>
    </div>
  </Card>
);

export default PlayerCard;


